import { Box, styled } from "@mui/material";

export const Choice = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 7px 10px;
  border: 1px solid #cdcdcd;
  background-color: white;
  color: #acb6be;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: left;
  cursor: pointer;
`;
